import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Product } from '../../../core/models/product-models';
import { CartService } from '../../../core/services/cart/cart.service'; 
import { Router, ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field'; 
@Component({
  selector: 'app-product-modal',
  standalone: true,
  imports: [CommonModule,
    MatButtonModule,
    MatIconModule,
    MatLabel,
    MatDialogModule,MatDialogActions,MatDialogClose,
    MatDialogContent,MatDialogTitle
  ],
  templateUrl: './product-modal.component.html',
  styleUrl: './product-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductModalComponent {
  cartService = inject(CartService);
  private router = inject(Router);
  dialogRef: any;
  isAddedToCart :boolean;
   isAddToCart :boolean;
   constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogRef: MatDialogRef<ProductModalComponent>
  ) {
    this.dialogRef = dialogRef;
    this.isAddedToCart = data.isAddedToCart;
    this.isAddToCart = data.isAddToCart;
  }
  

  onImgError(event: any) {
    event.target.src = 'assets/images/no-image-found.jpg';
    
  }
  addToCart(item: Product): void {
    this.data.isAddedToCart = true;
    this.data.isAddToCart = false
    this.cartService.addProductToCart(item);

    }
    cart() {
      this.router.navigateByUrl('cart');
      this.dialogRef.close();
    }
    closeDialog(): void {
      this.dialogRef.close();
    }
}
